import React from "react";
import * as S from "./textFeilds.style";
const SelectComponent = ({ selectOption, name, formik, disabled }) => {
  return (
    <>
      <div className="formControlInfo">
        {/* <S.SelecField
          {...formik.getFieldProps({ name })}
          name={name}
          disabled={disabled}
        >
          {selectOption.map((item) => (
            <option key={item.value} value={item.value}>
              {item.title}
            </option>
          ))}
        </S.SelecField> */}
        <select
          class="form-select form-select-md mb-3 "
          aria-label=".form-select-lg example"
          {...formik.getFieldProps({ name })}
          name={name}
          disabled={disabled}
        >
          {selectOption.map((item) => (
            <option key={item.value} value={item.value}>
              {item.title}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default SelectComponent;
